export default __webpack_public_path__ + "static/media/ssapLogo.579d67eb.svg";